import useLocationStore from '../../store/locatonStore';
import { getLocationNameFromOwnerId } from '../../utils/utility';

interface ComplianceCardProps {
  userName?: string;
  passwordExpiresIn?: number;
  lastLogin?: string; // Format: "MM/DD/YYYY hh:mm:ss A"
}

export default function ComplianceCard({
  userName,
  passwordExpiresIn,
  lastLogin,
}: ComplianceCardProps) {
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const parsedLoginDate = lastLogin ? new Date(lastLogin) : null;
  const isLoginDateValid = parsedLoginDate && !isNaN(parsedLoginDate.getTime());
  const locationName = getLocationNameFromOwnerId(selectedLocation.OwnerId);
  return (
    <div className="flex flex-col justify-start gap-2">
      <h2 className="text-text-primary font-bold pl-4 text-start pt-4">
        {locationName}
      </h2>

      <h2 className="text-text-primary font-bold pl-4 text-start">
        Booking System
      </h2>

      <h2 className="font-bold pl-4 text-start text-text-blue">
        Hello {userName || '--'}
      </h2>

      <p className="text-gray-700 text-start pl-4 text-text-darkGray">
        Password expires in{' '}
        <span className="font-medium">
          {passwordExpiresIn ? `${passwordExpiresIn} day(s)` : '--'}
        </span>
      </p>

      <p className="text-gray-700 text-start pl-4 text-text-darkGray">
        Last Login:{' '}
        <span>{isLoginDateValid ? parsedLoginDate.toDateString() : '--'}</span>
      </p>
    </div>
  );
}
